import { render, staticRenderFns } from "./setPerformance.vue?vue&type=template&id=1428eb50&scoped=true&"
import script from "./setPerformance.vue?vue&type=script&lang=js&"
export * from "./setPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1428eb50",
  null
  
)

export default component.exports